<template>
  <h1 class="font-anton text-2xl sm:text-4xl text-center mt-10 mb-8">
    <slot></slot>
  </h1>
</template>
